class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
 $(".compare-at-total-custom").insertAfter(".tdf-cart-total-parent.tdf-priced");
    
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    console.log("update qy");
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
        get_country();  //<- call custom function

        
      // custom code for custom shipping 
        
            const discountOpenerBtn = document.querySelector(".dec-button-popup");
            const discountPopup = document.querySelector(".dec-code-popup");
            const popupCloseBtn = document.querySelector(".popup-close-icon");
            const applyDiscountBtn = document.querySelector(".apply_discount_button");
            const normalBtn = document.querySelector("button.tdf_normal_btn");
            
            if (discountOpenerBtn && discountPopup) {
              discountOpenerBtn.addEventListener('click', () => {
                discountPopup.classList.add('active');
              });
            }
            
            if (popupCloseBtn && discountPopup) {
              popupCloseBtn.addEventListener('click', () => {
                discountPopup.classList.remove('active');
              });
            }
            
            if (applyDiscountBtn && normalBtn) {
              applyDiscountBtn.addEventListener('click', () => {
                normalBtn.click();
              });
            }

          const getcountryCode = document.querySelector('#CartDrawer')?.getAttribute("data-location");
    
          if(getcountryCode == 'ES' || getcountryCode == 'PT'){
          var goal = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-goal-1")*100;
          } else if(getcountryCode == 'FR' || getcountryCode == 'IT' || getcountryCode == 'DE'  || getcountryCode == 'BE' || getcountryCode == 'NL' || getcountryCode == 'GB' || getcountryCode == 'AT' || getcountryCode == 'BG' || getcountryCode == 'CY' || getcountryCode == 'DK' || getcountryCode == 'EE' || getcountryCode == 'SK' || getcountryCode == 'SI' || getcountryCode == 'FI' || getcountryCode == 'GR' || getcountryCode == 'HU' || getcountryCode == 'IE' || getcountryCode == 'LV' || getcountryCode == 'LT' || getcountryCode == 'LU' || getcountryCode == 'MT' || getcountryCode == 'PL' || getcountryCode == 'CZ' || getcountryCode == 'RO' || getcountryCode == 'SE'){
            var goal = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-goal-2")*100;
          }else{
            var goal = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-goal-3")*100;
          }
          const cartTotal = parsedState.original_total_price;
          if (cartTotal < goal) {
            const diff = goal - cartTotal;
            const diff_price = Shopify.formatMoney(diff,'{{amount}}€') ;
            const ship_text = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-missing").replace("{{goal}}", `<strong>${diff_price}</strong>`);
            document.querySelector(".fsb__msg").innerHTML = `<span>${ship_text}</span>`;

            var shipValue = ((goal - diff) * 100) / goal;
            document.querySelector(".ship-bar .ship-percentage").style.width = shipValue + "%";
         }else{
            const  ship_text = document.querySelector('.shipping_bar .fsb')?.getAttribute("data-congrats");
            document.querySelector(".fsb__msg").textContent = ship_text;
            document.querySelector(".ship-bar .ship-percentage").style.width = 100 + "%";
         }
        setTimeout(function(){
          hideshowGiftpdp();
        },1000);

      document.querySelectorAll('cart-drawer .freegift-row .freegift-row-productlist .cart-btn').forEach(function(button) {
      button.addEventListener('click', function(e) {
        button.closest(".col").classList.add("Gift_active");
           var col_1 = document.querySelector('.freegift-row-productlist .col_1');
          var col_2 = document.querySelector('.freegift-row-productlist .col_2');
          var col_3 = document.querySelector('.freegift-row-productlist .col_3');
          col_1.classList.add("disable");
          col_2.classList.add("disable");
          col_3.classList.add("disable");
        
        const arr = [];
        const mainProdId = this.getAttribute('data-id');
        arr.push({
          id: mainProdId,
          quantity: 1,
          properties: {
            "is_free_product": true
          }
        });

      let formData = {'items': arr};
    // console.log('formData-',formData);
          fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            }).then((response) => {
              return response.json();
            }).then((res) => {

            fetch(window.location.href, {
                      method: "GET",
                      headers: {
                          "Content-Type": "text/html"
                      }
                  })
                  .then(response => response.text())
                  .then(htmlContent => {
                      let doc = new DOMParser().parseFromString(htmlContent, "text/html");
                      let cartDrawerElement = doc.querySelector(".cart-drawer .drawer__contents");
                      if (cartDrawerElement) {
                          let currentCartDrawerElement = document.querySelector(".cart-drawer .drawer__contents");
                          if (currentCartDrawerElement) {
                              currentCartDrawerElement.outerHTML = cartDrawerElement.outerHTML;
                          }
                      }
                     hideshowGiftpdp();

            }).catch((err) => {
              /* uh oh, we have error. */
              console.error(err)
            });
              });
            });
});
        // end custom code for shipping bar
        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function get_country(){
  fetch('//get.geojs.io/v1/ip/country.json')
  .then(response => response.json())
  .then(location => {
    setTimeout(function(){
    const getCountry = location.country;
    console.log('country==>', getCountry);
    document.querySelector("#CartDrawer")?.setAttribute("data-location", getCountry);
    var tier1Text = document.querySelector(".announcement-bar-section")?.getAttribute("data-tier1text");
    var tier2Text = document.querySelector(".announcement-bar-section")?.getAttribute("data-tier2text");
    var tier3Text = document.querySelector(".announcement-bar-section")?.getAttribute("data-tier3text");
    if(getCountry == 'ES' || getCountry == 'PT'){
    // Tier 1
      var anno_msg = tier1Text ;
      document.querySelectorAll(".announcement-bar-section .announcement-text-wrap span").forEach(function(span) {span.textContent = anno_msg;});
      // document.querySelector(".shipping_bar .fsb")?.setAttribute("data-goal", "50");
      const el = document.querySelector(".freegift-row-productlist");
      if (el) {
        el.setAttribute("gift1", "7500");
        el.setAttribute("gift2", "10000");
        el.setAttribute("gift3", "15000");
      }
      document.querySelector(".freegift-row-productlist .card-image.first .price-barckpoint").innerHTML="From 75€";
      document.querySelector(".freegift-row-productlist .card-image.sec .price-barckpoint").innerHTML="From 100€";
      document.querySelector(".freegift-row-productlist .card-image.third .price-barckpoint").innerHTML="From 150€";

  } else if(getCountry == 'FR' || getCountry == 'IT' || getCountry == 'DE'  || getCountry == 'BE' || getCountry == 'NL' || getCountry == 'GB' || getCountry == 'AT' || getCountry == 'BG' || getCountry == 'CY' || getCountry == 'DK' || getCountry == 'EE' || getCountry == 'SK' || getCountry == 'SI' || getCountry == 'FI' || getCountry == 'GR' || getCountry == 'HU' || getCountry == 'IE' || getCountry == 'LV' || getCountry == 'LT' || getCountry == 'LU' || getCountry == 'MT' || getCountry == 'PL' || getCountry == 'CZ' || getCountry == 'RO' || getCountry == 'SE'){
    // Tier 2 
      var anno_msg = tier2Text ;
      document.querySelectorAll(".announcement-bar-section .announcement-text-wrap span").forEach(function(span) {span.textContent = anno_msg;});
      // document.querySelector(".shipping_bar .fsb")?.setAttribute("data-goal", "70");
      const el = document.querySelector(".freegift-row-productlist");
      if (el) {
        el.setAttribute("gift1", "9500");
        el.setAttribute("gift2", "12000");
        el.setAttribute("gift3", "17000");
      }
      document.querySelector(".freegift-row-productlist .card-image.first .price-barckpoint").innerHTML="From 95€";
      document.querySelector(".freegift-row-productlist .card-image.sec .price-barckpoint").innerHTML="From 120€";
      document.querySelector(".freegift-row-productlist .card-image.third .price-barckpoint").innerHTML="From 170€";

  } else {
    // Tier 3
      var anno_msg = tier3Text ;
      document.querySelectorAll(".announcement-bar-section .announcement-text-wrap span").forEach(function(span) {span.textContent = anno_msg;});
      // document.querySelector(".shipping_bar .fsb")?.setAttribute("data-goal", "100");
      const el = document.querySelector(".freegift-row-productlist");
      if (el) {
        el.setAttribute("gift1", "7500");
        el.setAttribute("gift2", "10000");
        el.setAttribute("gift3", "15000");
      }
      document.querySelector(".freegift-row-productlist .card-image.first .price-barckpoint").innerHTML="From 75€";
      document.querySelector(".freegift-row-productlist .card-image.sec .price-barckpoint").innerHTML="From 100€";
      document.querySelector(".freegift-row-productlist .card-image.third .price-barckpoint").innerHTML="From 150€";
  }
      },500);
  })
  .catch(error => {
    console.error('Error fetching country:', error);
  });
}


// custom function
function hideshowGiftpdp() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            // console.log("cart_total:-",cart.total_price);
            var gift_1 = document.querySelector('.freegift-row-productlist')?.getAttribute("gift1");
            var gift_2 = document.querySelector('.freegift-row-productlist')?.getAttribute("gift2");
            var gift_3 = document.querySelector('.freegift-row-productlist')?.getAttribute("gift3");

            var col_1 = document.querySelector('.freegift-row-productlist .col_1');
            var col_2 = document.querySelector('.freegift-row-productlist .col_2');
            var col_3 = document.querySelector('.freegift-row-productlist .col_3');
            var cartTotal = cart.original_total_price;
            // console.log("cartTotal:--",cartTotal,"gift_1:--",gift_1,"gift_2:--",gift_2,"gift_3:--",gift_3);

            const giftContainer = document.querySelector(".freegift-row-productlist");
            const gift1 = parseInt(giftContainer?.getAttribute("gift1") || 0, 10);
            const gift2 = parseInt(giftContainer?.getAttribute("gift2") || 0, 10);
            const gift3 = parseInt(giftContainer?.getAttribute("gift3") || 0, 10);
            const maxGiftPrice = Math.max(gift1, gift2, gift3);
            var is_gift_avail = false;

            cart.items.forEach(function(item, index) {
                if (item.properties && item.properties['is_free_product'] === true) {
                    is_gift_avail = true;
                }
                if (cart.items.length === 1 && /free|gift/i.test(cart.items[0].title)) {
                    const itemEl = document.querySelector(`[data-giftid='${item.id}']`);
                    if (itemEl) {
                        const removeBtn = itemEl.querySelector('cart-remove-button');
                        if (removeBtn) {
                            removeBtn.click();
                        }
                    }
                }
            });
            // console.log("check gift avail product-form:--",is_gift_avail);

            if (cartTotal < gift_1) {
                // console.log("iff 1");
                var gift1_id = document.querySelector(".freegift-row-productlist .col_1")?.getAttribute("data-vid");
                // console.log(gift1_id) ;
                var giftPriceDiff = gift_1 - cartTotal;
                var diff_price = Shopify.formatMoney(giftPriceDiff, '{{amount}}€');
                document.querySelector(".freegift-row-header p").innerHTML = `<strong>${diff_price}</strong> left to get a free gift`;
                col_1.classList.add("disable");
                col_2.classList.add("disable");
                col_3.classList.add("disable");
                // }
                var ship_width = (gift1 - giftPriceDiff) * 100 / maxGiftPrice;
                document.querySelector(".freegift-bar .freegift-percentage").style.width = ship_width + "%";
                if (is_gift_avail) {
                    col_1.classList.add("disable");
                    col_2.classList.add("disable");
                    col_3.classList.add("disable");
                }
                // Remove free gift items from cart
                cart.items.forEach(function(item) {
                    if (item.properties && item.properties['is_free_product'] === true && String(item.id) === String(gift1_id)) {
                        const itemEl = document.querySelector(`[data-giftid='${item.id}']`);
                        if (itemEl) {
                            const removeBtn = itemEl.querySelector('cart-remove-button');
                            if (removeBtn) {
                                removeBtn.click();
                            }
                        }
                    }
                });
                // Remove free gift items from cart

                // end Remove free gift items from cart
                // end Remove free gift items from cart
            } else if (cartTotal >= gift_1 && cartTotal < gift_2) {
                // console.log("iff 2");
                var gift2_id = document.querySelector(".freegift-row-productlist .col_2")?.getAttribute("data-vid");
                // console.log(gift2_id) ;
                var giftPriceDiff = gift_2 - cartTotal;
                var diff_price = Shopify.formatMoney(giftPriceDiff, '{{amount}}€');
                document.querySelector(".freegift-row-header p").innerHTML = `<strong>${diff_price}</strong> left to get your premium gift.`;
                col_1.classList.remove("disable");
                col_2.classList.add("disable");
                col_3.classList.add("disable");
                var ship_width = (gift2 - giftPriceDiff) * 100 / maxGiftPrice;
                document.querySelector(".freegift-bar .freegift-percentage").style.width = ship_width + "%";
                if (is_gift_avail) {
                    col_1.classList.add("disable");
                    col_2.classList.add("disable");
                    col_3.classList.add("disable");
                }
                // Remove free gift items from cart
                cart.items.forEach(function(item) {
                    if (item.properties && item.properties['is_free_product'] === true && String(item.id) === String(gift2_id)) {
                        const itemEl = document.querySelector(`[data-giftid='${item.id}']`);
                        if (itemEl) {
                            const removeBtn = itemEl.querySelector('cart-remove-button');
                            if (removeBtn) {
                                removeBtn.click();
                            }
                        }
                    }
                });
                // end Remove free gift items from cart
            } else if (cartTotal >= gift_2 && cartTotal < gift_3) {
                // console.log("iff 3");
                var gift3_id = document.querySelector(".freegift-row-productlist .col_3")?.getAttribute("data-vid");
                // console.log(gift3_id) ;
                var giftPriceDiff = gift_3 - cartTotal;
                var diff_price = Shopify.formatMoney(giftPriceDiff, '{{amount}}€');
                document.querySelector(".freegift-row-header p").innerHTML = `<strong>${diff_price}</strong> left to get your premium gift.`;
                col_1.classList.remove("disable");
                col_2.classList.remove("disable");
                col_3.classList.add("disable");
                var ship_width = (gift3 - giftPriceDiff) * 100 / maxGiftPrice;
                document.querySelector(".freegift-bar .freegift-percentage").style.width = ship_width + "%";
                if (is_gift_avail) {
                    col_1.classList.add("disable");
                    col_2.classList.add("disable");
                    col_3.classList.add("disable");
                }
                // Remove free gift items from cart
                cart.items.forEach(function(item) {
                    if (item.properties && item.properties['is_free_product'] === true && String(item.id) === String(gift3_id)) {
                        const itemEl = document.querySelector(`[data-giftid='${item.id}']`);
                        if (itemEl) {
                            const removeBtn = itemEl.querySelector('cart-remove-button');
                            if (removeBtn) {
                                removeBtn.click();
                            }
                        }
                    }
                });
                // end Remove free gift items from cart
            } else {
                // console.log("els");
                document.querySelector(".freegift-row-header p").textContent = "Congratulations! Select your free gift:"
                col_1.classList.remove("disable");
                col_2.classList.remove("disable");
                col_3.classList.remove("disable");
                document.querySelector(".freegift-bar .freegift-percentage").style.width = 100 + "%";
                if (is_gift_avail) {
                    col_1.classList.add("disable");
                    col_2.classList.add("disable");
                    col_3.classList.add("disable");
                }
            }
            var menu = ['', '', '']
            new Swiper('.cart-drawer-rc', {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 10,
                mousewheel: {
                    sensitivity: 1,
                    releaseOnEdges: true
                },
                pagination: {
                    el: ".cart-drawer-rc .swiper-pagination",
                    clickable: true,
                    renderBullet: function(index, className) {
                        return '<span class="' + className + '">' + (menu[index]) + '</span>';
                    },
                }
            });

        })
        .catch(error => console.error("Error fetching cart:", error));

}